import * as React from "react";
import autobind from "class-autobind";
import { logger } from "../../../../common/utils/logger/index";
import {InputGroup} from "../../form/input.group/index";
import {Input} from "../../form/input/index";
import {RotateLoader} from "../../loaders/rotate/index";
import { ProxySubdomainCheckUpdateRequest, ProxySubdomainCheckUpdateResponse} from "../../../../types/api/index";

interface Props {
  restaurant_id: string;
  website_id: string;
  base_domain: string;
  value: string;
  onChange: (subdomain: string) => void;
  checkDomain: (data: ProxySubdomainCheckUpdateRequest) => Promise<ProxySubdomainCheckUpdateResponse>;
  onCheckCallback: (e: string) => void;
}
interface State {
  loading: boolean;
}

export class FieldSubdomain extends React.Component<Props, State> {

  timer?: NodeJS.Timer | number;
  start_validating: boolean;

  constructor(props: Props) {
    super(props);
    autobind(this);
    this.state = {
      loading: false,
    };
    this.start_validating = false;
  }

  validate(subdomain: string) {
    if (!subdomain.match(/^[a-z0-9](?:[a-z0-9-_]{0,61}[a-z0-9])?$/) || subdomain.length <= 3 || subdomain.indexOf(".") !== -1) {
      logger.info("VALIDTE ERROR");
      this.props.onCheckCallback("Invalid sub-domain name. Sub-domains must start and end lowercase letters or numbers, be at least 4 characters and only contain the dashes and underscores in between ( - _ )");
      return false;
    }
    this.props.onCheckCallback("");
    return true;
  }

  onChange(e: React.ChangeEvent<HTMLInputElement>) {

    const { restaurant_id, website_id } = this.props;
    const subdomain = e.target.value;

    this.props.onChange(subdomain);

    if (subdomain.length > 3) {
      this.start_validating = true;
    }

    if (this.timer) { clearTimeout(this.timer as NodeJS.Timer); }

    if (this.start_validating && this.validate(subdomain)) {
      this.setState({ loading: true });
      this.timer = setTimeout(async () => {
        try {
          const data = await this.props.checkDomain({ subdomain, restaurant_id, website_id });
          this.props.onCheckCallback(data.outcome === 1 ? data.message : "");
        }
        catch (e) {
          this.props.onCheckCallback("Error validating sub-domain name, please try re-entering the name");
          logger.captureException(e);
        }
        this.setState({ loading: false });
      }, 1500);
    }
    else {
      this.setState({ loading: false });
    }

  }

  render() {
    return (
      <InputGroup
        side="right"
        iconHtml={this.state.loading ?
          <RotateLoader size={2} color="white"/> :
          <span>{this.props.base_domain}</span>
        }>
        <Input
          required={true}
          onChange={this.onChange}
          placeholder="Enter a name to check availability"
          value={this.props.value}/>
      </InputGroup>
    );
  }

}
